import { useTranslation } from "react-i18next";
import { formatAmount, printPaginationFooter } from "./helper";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "../primitives";

const DsrTable = (props) => {
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.no")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.billerId")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.billerName")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.settlementCount")}
            </TableCell>
            <TableCell align="right">
              {t("erps.statisticsEnquiry.page.label.settlementAmount")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.auditNo")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.settlementType")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.pageData.map((row) => (
            <TableRow key={row.id}>
              <TableCell align="left">{row?.id - 1}</TableCell>
              <TableCell align="left">{row?.externalBillerId}</TableCell>
              <TableCell align="left">{row?.billerName}</TableCell>
              <TableCell align="left">{row?.settlementCount}</TableCell>
              <TableCell align="right">
                {formatAmount(row?.settlementAmount)}
              </TableCell>
              <TableCell align="left">{row?.auditNumber}</TableCell>
              <TableCell align="left">{row?.settlementType}</TableCell>
            </TableRow>
          ))}
          {props.initialDataLength > 100 && (
            <TableRow key="paginate-footer">
              <TableCell colSpan={7} align="right">
                {printPaginationFooter(
                  props.rowPerPage,
                  props.pageNumber,
                  props.initialDataLength
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DsrTable;
